import { View } from 'foundations-components/components/View';
import { Flex } from 'foundations-components/components/Flex';
import Name from './components/InformationPopoverName';
import { jsx as _jsx } from "react/jsx-runtime";
export const InformationPopoverContentUI = ({
  label
}) => {
  return /*#__PURE__*/_jsx(Flex, {
    flexDirection: "column",
    alignItems: "start",
    marginBlockEnd: "400",
    onClick: event => {
      // prevent clicks inside the popover from triggering property selection
      event.stopPropagation();
    },
    children: /*#__PURE__*/_jsx(View, {
      marginBlockEnd: "100",
      inlineSize: "100%",
      children: /*#__PURE__*/_jsx(Name, {
        label: label,
        loading: false
      })
    })
  });
};